import {
  laptopMaxXL,
  laptopMediumMax,
  laptopSmallMax,
  mobileXLargeMax,
  tabletMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import Dev1 from '@propertypal/shared/src/resources/images/development-microsites/developer-01.jpg';
import Dev2 from '@propertypal/shared/src/resources/images/development-microsites/developer-02.jpg';
import Dev3 from '@propertypal/shared/src/resources/images/development-microsites/developer-03.jpg';
import Dev4 from '@propertypal/shared/src/resources/images/development-microsites/developer-04.jpg';
import Dev5 from '@propertypal/shared/src/resources/images/development-microsites/developer-05.jpg';
import Dev6 from '@propertypal/shared/src/resources/images/development-microsites/developer-06.jpg';
import Agent1 from '@propertypal/shared/src/resources/images/estate-agent-websites/agent-01.jpg';
import Agent2 from '@propertypal/shared/src/resources/images/estate-agent-websites/agent-02.jpg';
import Agent3 from '@propertypal/shared/src/resources/images/estate-agent-websites/agent-03.jpg';
import Agent4 from '@propertypal/shared/src/resources/images/estate-agent-websites/agent-04.jpg';
import Agent5 from '@propertypal/shared/src/resources/images/estate-agent-websites/agent-05.jpg';
import Agent6 from '@propertypal/shared/src/resources/images/estate-agent-websites/agent-06.jpg';
import BasePlateImg from '@propertypal/shared/src/resources/images/estate-agent-websites/baseplate.png';
import { Container as Button } from '@propertypal/web-ui/src/buttons/Button.style';
import { Content as PageWrapper } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import styled, { css, keyframes } from 'styled-components';

export const xlLaptopBreakpoint = 'max-width: 1200px';
export const laptopBreakpoint = 'max-width: 1080px';

const DEV_IMAGES = [Dev1, Dev2, Dev3, Dev4, Dev5, Dev6];
const AGENT_IMAGES = [Agent1, Agent2, Agent3, Agent4, Agent5, Agent6];

const laptopAnim = (dev?: boolean) => keyframes`
  0%, 8%{
    background-image: url(${(dev ? DEV_IMAGES : AGENT_IMAGES)[0].src});
  }
  16%, 24% {
    background-image: url(${(dev ? DEV_IMAGES : AGENT_IMAGES)[1].src});
  }
  32%, 40% {
    background-image: url(${(dev ? DEV_IMAGES : AGENT_IMAGES)[2].src});
  }
  48%, 56% {
    background-image: url(${(dev ? DEV_IMAGES : AGENT_IMAGES)[3].src});
  }
  64%, 72% {
    background-image: url(${(dev ? DEV_IMAGES : AGENT_IMAGES)[4].src});
  }
  80%, 88% {
    background-image: url(${(dev ? DEV_IMAGES : AGENT_IMAGES)[5].src});
  }
  100% {
    background-image: url(${(dev ? DEV_IMAGES : AGENT_IMAGES)[0].src});
  }
`;

export const Container = styled.div`
  background: ${({ theme }) => theme.primary};
  position: relative;
  width: 100%;
  padding: 45px 0 180px 0;

  ${PageWrapper} {
    max-width: 1380px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 95px;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  @media (${laptopMediumMax}) {
    gap: 45px;
  }

  @media screen and (${tabletMax}) {
    flex-direction: column;
  }
`;

export const Laptop = styled.div`
  position: relative;
  width: 100%;
  height: 410px;

  @media (${laptopBreakpoint}) {
    height: 300px;
  }

  @media (${mobileXLargeMax}) {
    height: 181px;
  }
`;

export const BasePlate = styled.div`
  background-image: url(${BasePlateImg.src});
  background-size: contain;
  position: absolute;
  height: 410px;
  width: 680px;

  @media (${laptopMaxXL}) {
    left: -120px;
  }

  @media (${laptopBreakpoint}) {
    width: 560px;
    height: 338px;
    left: -110px;
  }

  @media (${laptopSmallMax}) {
    width: 470px;
    height: 283px;
    left: -85px;
  }

  @media (${tabletMax}) {
    left: 50%;
    transform: translateX(-234px);
  }

  @media (${mobileXLargeMax}) {
    width: 300px;
    height: 181px;
    transform: translateX(-150px);
  }
`;

export const LaptopImage = styled.div<{ dev?: boolean }>`
  position: absolute;
  background-size: cover;
  top: 18px;
  left: 97px;
  width: 487px;
  height: 305px;
  animation-name: ${({ dev }) => laptopAnim(dev)};
  animation-duration: 25s;
  animation-iteration-count: infinite;

  /** 
   * preload all images hack? helps reduce likelyhood of white screen due to image loading 
   * https://app.shortcut.com/propertypal/story/26094/developer-agent-websites-page#activity-26412
  */
  &:after {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
    content: ${({ dev }) => (dev ? DEV_IMAGES : AGENT_IMAGES).map((img) => css`url(${img.src})`)}; // load images
  }

  @media (${laptopBreakpoint}) {
    width: 403px;
    height: 253px;
    top: 14px;
    left: 79px;
  }

  @media (${laptopSmallMax}) {
    width: 338px;
    height: 211px;
    top: 12px;
    left: 66px;
  }

  @media (${mobileXLargeMax}) {
    width: 215px;
    height: 135px;
    top: 8px;
    left: 43px;
  }
`;

export const ContentText = styled.div`
  width: 100%;
  max-width: 540px;

  ${SubHeading} {
    color: ${({ theme }) => theme.white};
    line-height: 1.1;

    @media (${xlLaptopBreakpoint}) {
      font-size: 55px;
    }

    @media (${laptopBreakpoint}) {
      font-size: 48px;
    }

    @media (${laptopSmallMax}) {
      font-size: 40px;
    }

    @media (${mobileXLargeMax}) {
      font-size: 32px;
    }
  }

  ${Text} {
    color: ${({ theme }) => theme.white};
    line-height: 1.5;
    font-size: 20px;
    margin-bottom: 35px;
  }

  ${Button} {
    background-color: ${({ theme }) => theme.darkGrey};

    &:hover {
      background-color: ${({ theme }) => theme.backgroundMid};
    }
  }

  @media (${tabletMax}) {
    margin: 0 auto;
    text-align: center;

    ${Button} {
      margin: 0 auto;
    }
  }
`;

export const ContentTextWraper = styled.div`
  max-width: 400px;

  @media (${tabletMax}) {
    margin: 0 auto;
    text-align: center;
  }
`;
